// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"85824cbe","453":"93da1fef"}[chunkId] + ".chunk.js";
};